import clsx from 'clsx';

export function SkeletonLine({
  width = 'w-full',
  height = 'h-3',
  className,
}: {
  width?: string;
  height?: string;
  className?: string;
}): React.ReactNode {
  return <div className={clsx('shimmer rounded', width, height, className)} />;
}

export function SkeletonCard({ className }: { className?: string }): React.ReactNode {
  return (
    <div className={clsx('space-y-2 rounded-md border border-ink-800 bg-ink-900/30 p-3', className)}>
      <SkeletonLine width="w-16" height="h-2" />
      <SkeletonLine width="w-3/4" height="h-3" />
      <SkeletonLine width="w-1/2" height="h-2" />
      <SkeletonLine />
    </div>
  );
}
